import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { BrandHeader } from '@fuww/library/src/CompanyProfile';
import Layout from '../Layout';
import HeaderImage from './HeaderImage';
import Image from '../Image';
import throw404 from '../../lib/throw404';

const companyPropertyTypes = {
  data: PropTypes.shape({
    profileBySlug: PropTypes.shape({
      page: PropTypes.shape({
        title: PropTypes.string.isRequired,
        contactDetails: PropTypes.string,
      }).isRequired,
      company: PropTypes.shape({
        logoUrls: PropTypes.arrayOf(PropTypes.string),
      }).isRequired,
      type: PropTypes.string,
    }),
  }).isRequired,
  children: PropTypes.node.isRequired,
  layoutMaxWidth: PropTypes.string.isRequired,
  layoutMarginBottom: PropTypes.string,
  throwOnCompanyNotFound: PropTypes.bool,
};

type CompanyProperties = InferProps<typeof companyPropertyTypes>;

const Company = ({
  data: { profileBySlug },
  children,
  layoutMaxWidth,
  layoutMarginBottom,
  throwOnCompanyNotFound,
}: CompanyProperties) => {
  if (!profileBySlug) {
    return throw404();
  }

  const {
    type,
    page,
    company,
  } = profileBySlug;

  const { title } = page;
  const { logoUrls } = company;

  if (throwOnCompanyNotFound && type !== 'COMPANY') {
    return throw404();
  }

  return (
    <Layout
      overflow="visible"
      header={(
        <>
          <HeaderImage profile={profileBySlug} />
          {title && (
            <BrandHeader
              logo={logoUrls?.[0] && logoUrls[1] && (
                <Image
                  src={logoUrls[1]}
                  alt={`Logo ${title}`}
                  width="102px"
                  height="102px"
                  sizes="102px"
                  placeholder={logoUrls[0]}
                  srcSet={[
                    `${logoUrls[1]} 102w`,
                    logoUrls[2] && `${logoUrls[2]} 204w`,
                    logoUrls[3] && `${logoUrls[3]} 306w`,
                  ].filter(Boolean).join(', ')}
                  finalFetchpriority="high"
                  placeholderFetchpriority="high"
                  preload
                  disableRoundedCorners
                />
              )}
              brandName={title}
            />
          )}
        </>
      )}
      layoutMaxWidth={layoutMaxWidth}
      layoutMarginBottom={layoutMarginBottom}
    >
      {children}
    </Layout>
  );
};

Company.propTypes = companyPropertyTypes;

export default Company;
